Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("../../../../styles");
var _reactNative = require("react-native-web");
var useStyles = exports.useStyles = function useStyles(_ref) {
  var sharedStyles = _ref.sharedStyles;
  var colors = sharedStyles.colors,
    paragraph = sharedStyles.paragraph,
    fontRegular = sharedStyles.fontRegular;
  var styles = _reactNative.StyleSheet.create({
    list: {
      width: '100%',
      marginBottom: _reactNative.Platform.OS === 'web' ? "calc(".concat(paragraph.marginBottom, " / 2)") : paragraph.marginBottom / 2
    },
    listItem: {
      flexDirection: 'row',
      marginBottom: _reactNative.Platform.OS === 'web' ? "calc(".concat(paragraph.marginBottom, " / 2)") : paragraph.marginBottom / 2,
      alignItems: 'flex-start'
    },
    number: Object.assign({}, fontRegular, {
      fontSize: paragraph.fontSize,
      lineHeight: paragraph.lineHeight,
      color: colors.text,
      width: (0, _styles.getREM)(1.5),
      flexShrink: 0
    }),
    bullet: {
      fontFamily: paragraph.fontFamily,
      color: paragraph.color,
      fontSize: _styles.STYLES.fontSize.xl,
      lineHeight: _reactNative.Platform.OS === 'web' ? "calc(".concat(paragraph.fontSize, " * 1.5)") : paragraph.fontSize * 2,
      width: (0, _styles.getREM)(1.5),
      flexShrink: 0
    },
    text: {
      fontSize: paragraph.fontSize,
      lineHeight: paragraph.lineHeight,
      fontFamily: paragraph.fontFamily,
      color: paragraph.color,
      flex: 1
    }
  });
  return {
    styles: styles
  };
};